import { render, staticRenderFns } from "./LabelCanvasThumbnail.vue?vue&type=template&id=10d70e9c&scoped=true&"
import script from "./LabelCanvasThumbnail.vue?vue&type=script&lang=js&"
export * from "./LabelCanvasThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./LabelCanvasThumbnail.vue?vue&type=style&index=0&id=10d70e9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d70e9c",
  null
  
)

export default component.exports